import Listar from '@/views/Culturas/Listar'
import Form from '@/views/Culturas/Form'

const routes = [
    {
        meta: {auth: true},
        path: '/culturas',
        name: 'culturas',
        component: Listar
    },

    {
        meta: {auth: true},
        path: '/culturas/adicionar',
        name: 'culturas.adicionar',
        component: Form
    },

    {
        meta: {auth: true},
        path: '/culturas/editar/:id',
        name: 'culturas.editar',
        component: Form
    }

]
export default routes
